var exports = {
  "kL": "x4ddf2309--92ce68--container",
  "$h": "x4ddf2309--92ce68--closed",
  "Qs": "x4ddf2309--92ce68--content",
  "R_": "x4ddf2309--92ce68--heading",
  "DD": "x4ddf2309--92ce68--title",
  "c5": "x4ddf2309--92ce68--arrow-wrapper",
};

module.exports = exports;
